import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const detectDeviceLanguage = () => {
  const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  return nav.startsWith('fr') ? 'fr-FR' : 'en-US';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(detectDeviceLanguage);

  const languages = {
    'en-US': {
      code: 'en-US',
      name: 'English (US)',
      flag: '🇺🇸'
    },
    'fr-FR': {
      code: 'fr-FR', 
      name: 'Français',
      flag: '🇫🇷'
    }
  };

  const isFr = language === 'fr-FR';
  const tr = (en, fr) => (isFr ? fr : en);

  const value = {
    language,
    setLanguage,
    languages,
    currentLanguage: languages[language],
    isFr,
    tr
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
